// extracted by css-extract-rspack-plugin
export default {"maxHeight":"AttachmentsTabPanel_maxHeight__qlqbO","wrapper":"AttachmentsTabPanel_wrapper__O5J5n"};